import OSS from 'ali-oss'

/**
 * 获取 STS（你自己的后端接口）
 */
async function getSTS() {
	const res = await fetch('https://ht.daiyuart.com/api.php/set/Other/sts')
	if (!res.ok) throw new Error('获取 STS 失败')
	return res.json()
}

/**
 * 上传文件到 OSS
 * @param {File} file
 * @param {Function} onProgress
 */
export async function uploadToOSS(file, onProgress) {
	const {
		data
	} = await getSTS()

	const client = new OSS({
		region: data.region.startsWith('oss-') ? data.region : 'oss-' + data.region,
		bucket: data.bucket,
		accessKeyId: data.accessKeyId,
		accessKeySecret: data.accessKeySecret,
		stsToken: data.securityToken,
		endpoint: `https://oss-cn-qingdao.aliyuncs.com`,
		secure: true,
	})

	const ext = file.name.split('.').pop()
	const fileName = `uploads/${file.uid}_${Math.random().toString(36).slice(2)}.${ext}`

	const result = await client.put(fileName, file, {
		progress: p => {
			onProgress && onProgress(Math.floor(p * 100))
		}
	})

	return result.url
}